/*
 * Protocol Signup
 * Inline email capture for protocol pages. Same Klaviyo client-side subscribe
 * endpoint as the popup, but always visible and never suppressed, because paid
 * traffic must see the offer immediately rather than wait for a trigger.
 * Fires a Meta Lead event on success so ad delivery has something to optimise toward.
 */
(function () {
  'use strict';

  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var KLAVIYO_REVISION = '2024-10-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function Signup(root) {
    this.root = root;
    this.listId = root.getAttribute('data-list-id') || '';
    this.company = root.getAttribute('data-company') || '';
    this.source = root.getAttribute('data-source') || 'kimorii protocol page';
    this.form = root.querySelector('.p-sgn-form');
    this.emailInput = root.querySelector('input[type="email"]');
    this.errorEl = root.querySelector('.p-sgn-error');
    this.successEl = root.querySelector('.p-sgn-success');
    this.formWrap = root.querySelector('.p-sgn-formwrap');
    this.submitBtn = root.querySelector('button[type="submit"]');
  }

  Signup.prototype.init = function () {
    if (!this.form || !this.listId || !this.company) return;
    var self = this;
    this.form.addEventListener('submit', function (e) { self.submit(e); });
  };

  Signup.prototype.setError = function (msg) {
    if (this.errorEl) {
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
    }
  };

  Signup.prototype.submit = function (e) {
    e.preventDefault();
    if (this.errorEl) this.errorEl.hidden = true;

    var email = (this.emailInput.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      this.setError('Please enter a valid email address.');
      this.emailInput.focus();
      return;
    }

    var self = this;
    var originalLabel = this.submitBtn.textContent;
    this.submitBtn.disabled = true;
    this.submitBtn.textContent = '…';

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: self.source,
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: self.listId } } }
      }
    };

    fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(self.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.status === 202 || (res.status >= 200 && res.status < 300)) {
        self.onSuccess(email);
      } else {
        throw new Error('subscribe failed');
      }
    }).catch(function () {
      self.submitBtn.disabled = false;
      self.submitBtn.textContent = originalLabel;
      self.setError('Something went wrong. Please try again in a moment.');
    });
  };

  Signup.prototype.onSuccess = function (email) {
    try {
      if (window.klaviyo && window.klaviyo.push) {
        window.klaviyo.push(['identify', { $email: email }]);
      }
    } catch (err) {}

    // Meta Lead event. The pixel is a Shopify web pixel and loads async, so retry briefly.
    try {
      var leadSource = this.source;
      var tries = 0;
      var fire = function () {
        if (window.fbq) {
          window.fbq('track', 'Lead', {
            content_name: leadSource,
            content_category: 'email signup'
          });
          return;
        }
        if (++tries < 20) window.setTimeout(fire, 250);
      };
      fire();
    } catch (err) {}

    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('kimorii_lead', { source: this.source });
      }
    } catch (err) {}

    // Tell every other signup block on the page, so a second form doesn't ask again.
    try {
      document.querySelectorAll('[data-protocol-signup]').forEach(function (el) {
        var wrap = el.querySelector('.p-sgn-formwrap');
        var ok = el.querySelector('.p-sgn-success');
        if (wrap) wrap.hidden = true;
        if (ok) ok.hidden = false;
      });
    } catch (err) {}

    if (this.successEl) {
      var h = this.successEl.querySelector('h3');
      if (h) {
        h.setAttribute('tabindex', '-1');
        try { h.focus(); } catch (err) {}
      }
    }
  };

  function init() {
    var roots = document.querySelectorAll('[data-protocol-signup]');
    Array.prototype.forEach.call(roots, function (root) { new Signup(root).init(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
